export const USER_ROLES = {
    ADMIN : 1,
    USER : 2
}
